
  import { Address } from '@/scripts/address';
  import { ADDRESS_FIELDS } from '@/constants/addresses';
  import { mapGetters } from 'vuex';

  export default {
    data () {
      return {
        address: null,
        addressFields: ADDRESS_FIELDS,
        editProfile: false,
        formDisabled: false
      };
    },
    computed: {
      ...mapGetters('products', { underMaintenance: 'getCarAndHomeInsuranceUnderMaintenance' }),
      ...mapGetters('search', { search: 'get' }),
      canonicalAddress () {
        return this.address ? new Address(this.address).canonical : null;
      },
      canShowUserProfileCard () {
        return this.$store.getters['user/canShowUserAddressCard'];
      },
      showUserProfileCard () {
        if (this.editProfile) {
          return false;
        }
        return this.canShowUserProfileCard;
      },
      user () {
        return this.$store.getters['user/get'];
      }
    },
    created () {
      if (this.canShowUserProfileCard) {
        this.$store.commit('utils/clearAddress', 'default');
        this.address = this.user.supply_address;
      }
    },
    methods: {
      editAddress () {
        this.address = null;
        this.editProfile = true;
      },
      proceed (address) {
        if (this.address === null) {
          this.address = address;
        }
        if (this.address === null) return;

        this.formDisabled = true;
        this.$store.dispatch('matomo/trackFunnelStepCompleted', {name: 'Home Step 0 - Index - address submitted'});
        this.$cookies.set('bonkers-ie-home-insurance-capture-point', this.address);
        this.$router.push('/compare-home-insurance/your-home/');
      }
    }
  };
